import ReactHabitat from 'react-habitat';
import { CartSC as Cart } from 'components/Cart/Cart';
import { SubscriptionSectionSC as SubscriptionSection } from 'components/SubscriptionSection/SubscriptionSection';
import { FeaturedEventsSC as FeaturedEvents } from 'components/FeaturedEvents/FeaturedEvents';
import { UpcomingEventsSC as UpcomingEvents } from 'components/UpcomingEvents/UpcomingEvents';
import { WhatsOnTodaySC as WhatsOnToday } from 'components/WhatsOnToday/WhatsOnToday';
import { EventFinderSC as EventFinder } from 'components/EventFinder/EventFinder';
import { SearchFormAndResultsSC as SearchFormAndResults } from 'components/SearchFormAndResults/SearchFormAndResults';
import { OpenBookingModalButtonSC as OpenBookingModalButton } from 'components/UI/OpenBookingModalButton/OpenBookingModalButton';
import { BestAvailableSeatsSC as BestAvailableSeats } from 'components/BestAvailableSeats/BestAvailableSeats';
import { RegistrationFormSC as RegistrationForm } from 'components/RegistrationForm/RegistrationForm';
import { LoginForm } from 'components/LoginForm/LoginForm';
import { ForgotPasswordForm } from 'components/ForgotPasswordForm/ForgotPasswordForm';
import { BookingDeliveryMethodsSC as BookingDeliveryMethods } from 'components/BookingDeliveryMethods/BookingDeliveryMethods';
import { BookingOrderSummarySC as BookingOrderSummary } from 'components/BookingOrderSummary/BookingOrderSummary';
import { BookingConfirmationSC as BookingConfirmation } from 'components/BookingConfirmation/BookingConfirmation';
import { PaymentPageSC as PaymentPage } from 'components/Payment/PaymentPage';
import { FeaturedEventsForContentSC as FeaturedEventsForContent } from 'components/FeaturedEventsForContent/FeaturedEventsForContent';
import { ConfirmSeatsSC as ConfirmSeats } from 'components/Cart/ConfirmSeats';
import { WhatsOnGenreSC as WhatsOnGenre } from 'components/WhatsOnGenre/WhatsOnGenre';
import { UpsellsPageSC as UpsellsPage } from 'components/UpsellsPage/UpsellsPage';
import { EventCalendarPageSC as EventCalendarPage } from 'components/EventCalendarPage/EventCalendarPage';
import { RegistrationFormCompleteSC as RegistrationFormComplete } from 'components/RegistrationFormComplete/RegistrationFormComplete';
import { PreferencesFormSC as PreferencesForm } from 'components/PreferencesForm/PreferencesForm';
import { AccountInformationSC as AccountInformation } from 'components/AccountInformation/AccountInformation';
import { MembershipPageSC as MembershipPage } from 'components/MembershipPage/MembershipPage';
import { ChangePassword } from 'components/ChangePassword/ChangePassword';
import { GiftVouchersSC as GiftVouchers } from 'components/GiftVouchers/GiftVouchers';
import { ResetPasswordFormSC as ResetPasswordForm } from 'components/ResetPasswordForm/ResetPasswordForm';
import { DeliveryAddressFormSC as DeliveryAddressForm } from 'components/DeliveryAddressForm/DeliveryAddressForm';

class MyApp extends ReactHabitat.Bootstrapper {
  constructor() {
    super();

    // Create a new container builder:
    const builder = new ReactHabitat.ContainerBuilder();

    // Register a component:
    builder.register(EventFinder).as('EventFinder');
    builder.register(WhatsOnToday).as('WhatsOnToday');
    builder.register(UpcomingEvents).as('UpcomingEvents');
    builder.register(SubscriptionSection).as('SubscriptionSection');
    builder.register(FeaturedEvents).as('FeaturedEvents');
    builder.register(SearchFormAndResults).as('SearchFormAndResults');
    builder.register(Cart).as('Cart');
    builder.register(RegistrationForm).as('RegistrationForm');
    builder.register(LoginForm).as('LoginForm');
    builder.register(BookingDeliveryMethods).as('BookingDeliveryMethods');
    builder.register(OpenBookingModalButton).as('OpenBookingModalButton');
    builder.register(BestAvailableSeats).as('BestAvailableSeats');
    builder.register(BookingOrderSummary).as('BookingOrderSummary');
    builder.register(BookingConfirmation).as('BookingConfirmation');
    builder.register(PaymentPage).as('PaymentPage');
    builder.register(FeaturedEventsForContent).as('FeaturedEventsForContent');
    builder.register(ConfirmSeats).as('ConfirmSeats');
    builder.register(WhatsOnGenre).as('WhatsOnGenre');
    builder.register(UpsellsPage).as('UpsellsPage');
    builder.register(EventCalendarPage).as('EventCalendarPage');
    builder.register(RegistrationFormComplete).as('RegistrationFormComplete');
    builder.register(PreferencesForm).as('PreferencesForm');
    builder.register(ForgotPasswordForm).as('ForgotPasswordForm');
    builder.register(DeliveryAddressForm).as('AddressManagementForm');
    builder.register(AccountInformation).as('AccountInformation');
    builder.register(MembershipPage).as('MembershipPage');
    builder.register(ChangePassword).as('ChangePassword');
    builder.register(GiftVouchers).as('GiftVouchers');
    builder.register(ResetPasswordForm).as('ResetPasswordForm');
    // // Or register a component to load on demand asynchronously:
    // builder.registerAsync(() => System.import('./UI/Button')).as('Button');

    // Finally, set the container:
    this.setContainer(builder.build());

    window.updateHabitat = this.update.bind(this);
  }
}

// Always export a 'new' instance so it immediately evokes:
export default new MyApp();
